"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_VALUE_PAIR_SEPARATOR = exports.STRATEGY_NODE_PATH_SEPARATOR = exports.ATTRIBUTE_PROPERTY_DELIMITER = exports.UNCATEGORIZED_ID = exports.ENRICH_REDUX_SLICE_KEY = exports.PREFIX_ENRICH = void 0;
exports.PREFIX_ENRICH = 'ENRICH:';
exports.ENRICH_REDUX_SLICE_KEY = 'enrich';
exports.UNCATEGORIZED_ID = 'UNCATEGORIZED';
exports.ATTRIBUTE_PROPERTY_DELIMITER = '\t';
exports.STRATEGY_NODE_PATH_SEPARATOR = '.';
exports.LABEL_VALUE_PAIR_SEPARATOR = 'clwqejuj900003b6tmeilfgsq';
